// Get all alarm page list
const ALARM_PAGE_GET_DATA = {
  ALARM_PAGE_GET_DATA_LOAD: "ALARM_PAGE_GET_DATA_LOAD",
  ALARM_PAGE_GET_DATA_SUCCESS: "ALARM_PAGE_GET_DATA_SUCCESS",
  ALARM_PAGE_GET_DATA_FAIL: "ALARM_PAGE_GET_DATA_FAIL",
};
const ALARM_PAGE_DATA_GET_API = "/alarm/all ";

// Get alarm page by id
const ALARM_PAGE_GET_DETAILS_DATA = {
  ALARM_PAGE_GET_DETAILS_DATA_LOAD: "ALARM_PAGE_GET_DETAILS_DATA_LOAD",
  ALARM_PAGE_GET_DETAILS_DATA_SUCCESS: "ALARM_PAGE_GET_DETAILS_DATA_SUCCESS",
  ALARM_PAGE_GET_DETAILS_DATA_FAIL: "ALARM_PAGE_GET_DETAILS_DATA_FAIL",
};
const ALARM_PAGE_GET_DETAIL_API = "/alarm/";

// Update alarm page
const ALARM_PAGE_UPDATE_DATA = {
  ALARM_PAGE_UPDATE_DATA_LOAD: "ALARM_PAGE_UPDATE_DATA_LOAD",
  ALARM_PAGE_UPDATE_DATA_SUCCESS: "ALARM_PAGE_UPDATE_DATA_SUCCESS",
  ALARM_PAGE_UPDATE_DATA_FAIL: "ALARM_PAGE_UPDATE_DATA_FAIL",
  ALARM_PAGE_UPDATE_DATA_RESET: "ALARM_PAGE_UPDATE_DATA_RESET",
};
const ALARM_PAGE_POST_API = "/alarm/status";

export {
  ALARM_PAGE_GET_DATA,
  ALARM_PAGE_DATA_GET_API,
  ALARM_PAGE_GET_DETAILS_DATA,
  ALARM_PAGE_GET_DETAIL_API,
  ALARM_PAGE_UPDATE_DATA,
  ALARM_PAGE_POST_API,
};